<template>
  <div class="content">
    <controlbar
      :dispItems="careworkers"
      @input-event="setCareworker"
      @list-reload="reload"
    >
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="user_id_label">
              {{ userIdLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="careworker_name_label">
              {{ careworkerNameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="post_name_label">
              {{ postNameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="job_label">
              {{ jobLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="position_label">
              {{ positionLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispCareworker in careworkers"
            :key="dispCareworker.userId"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispCareworker.checked"
                @click="checkedAction(dispCareworker)"
              />
            </th>
            <td class="table_contents" @click="setActive(dispCareworker)">
              <label class="user_id">
                {{ dispCareworker.userId }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCareworker)">
              <label class="careworker_name">
                {{ dispCareworker.familyName }}{{ dispCareworker.name }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCareworker)">
              <label class="post_name">
                {{ dispCareworker.postName }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCareworker)">
              <label class="job">
                {{ dispCareworker.job }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispCareworker)">
              <label class="position">
                {{ dispCareworker.position }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setCareworker(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import Pagination from 'vue-pagination-2'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      userIdLabel: 'ユーザID',
      careworkerNameLabel: '名前',
      postNameLabel: 'メイン所属',
      jobLabel: '職種',
      positionLabel: '役職',
      showFalseModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    careworkers() {
      return this.$store.state.careworkers.careworkers
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.careworkers.total
      ) {
        return this.$store.state.careworkers.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.careworkers.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.careworkers.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('careworkers/clearSelectedCareworkerList')
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setCareworker(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    Pagination,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    close(e) {
      this.showFalseModal = false
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.careworkers.length; i++) {
        this.careworkers[i].checked = this.checked
      }
      this.$store.dispatch(
        'careworkers/updateSelectedCareworkerList',
        this.careworkers
      )
    },
    checkedAction(careworker) {
      careworker.checked = !careworker.checked
      this.$store.dispatch('careworkers/updateSelectedCareworkerList', [
        careworker
      ])
    },
    async reload() {
      this.$store.dispatch('careworkers/clearSelectedCareworkerList')
      await this.setCareworker(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setCareworker(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('careworkers/setCareworkers', {
          pageNo: pageNo,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_230001
        let eventType = 3
        let reason = 'MSGCRC0047 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0047.name +
            this.errorMsg.MSGCRC0047.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('careworkers/setDetailCareworker', payload)
        try {
          if (this.$store.state.careworkers.careworker.thumbnailPhotograph) {
            await this.$store.dispatch(
              'careworkers/fileDownload',
              this.$store.state.careworkers.careworker.thumbnailPhotograph
            )
          }
          if (location.pathname !== '/careworkers/detail') {
            this.$router.push('../careworkers/detail')
          }
        } catch (error) {
          this.$store.dispatch(
            'careworkers/setNoimageChangeThumbnailPhotograph'
          )
          let eventNumber = this.$store.state.error.errorCode.errorCode_230002
          let eventType = 3
          let reason = 'MSGCRC0196 '
          this.falseWord =
            this.errorMsg.MSGCRC0196.name +
            this.errorMsg.MSGCRC0196.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          // 画像ダウンロード失敗の場合でも画面遷移する
          if (location.pathname !== '/careworkers/detail') {
            this.$router.push('../careworkers/detail')
          }
          this.showFalseModal = true
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_230002
        let eventType = 3
        let reason = 'MSGCRC0048 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0048.name +
            this.errorMsg.MSGCRC0048.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
td {
  width: 20%;
}
td:nth-child(4) {
  table-layout: fixed;
  width: 22%;
}
</style>



// WEBPACK FOOTER //
// src/components/careworkers/careworkersList.vue